import apiServices from "../apiServices";
import { validateOrThrowApiResponse } from "../response-validator";

const gameWizardAPI = {
    getSwapOptions(gameType: string) {
        return apiServices
            .get(`/api/game/swap-options?game_type=${encodeURIComponent(gameType)}`, {
                headers: { Accept: "application/json" },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error getSwapOptions:", err);
                return null;
            });
    },

    cloneTemplateWithGameType(payload: { source_uuid: string; teacher_uuid: string; game_type: string }) {
        return apiServices
            .post(`/api/game/clone-template-with-game-type`, payload, {
                headers: { Accept: "application/json" },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error cloneTemplateWithGameType:", err);
                return null;
            });
    },

    updateGameType(payload: { game_uuid: string; game_type: string }) {
        return apiServices
            .patch(`/api/game/update-game-type`, payload, {
                headers: { Accept: "application/json" },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error updateGameType:", err);
                return null;
            });
    },
};

export default gameWizardAPI;
